import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  createAdminUserStart,
  getAdminUserDetailsStart,
  getAllGroupsStart,
  updateTenantAdminUserStart
} from '../../../../store/redux-slices/adminUser'
import { permissionLabel } from '../../../../components/ProfilePage/constants'

const useCreateAdminUser = ({ groupId, tenantIds }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [type, setType] = useState('password')

  const { tenantAdminRole } = useSelector((state) => state.login)
  const { tenantsList } = useSelector((state) => state.tenants)
  const { adminDetails, groupDetail } = useSelector(state => state.admins)
  const { groups } = useSelector(state => state.adminUser)

  const { tenantAdminsData } = useSelector(state => state.tenantsFetch)

  const [groupOptions, setGroupOptions] = useState([])
  const [selectedGroup, setSelectedGroup] = useState()
  const [tenantIdOptions, setTenantIdOptions] = useState([])

  const updateTenantAdminUser = (data) =>
    dispatch(
      updateTenantAdminUserStart(data)
    )

  const createTenantAdminUser = (data) =>
    dispatch(
      createAdminUserStart(data)
    )

  const getAdminUserDetails = (adminUserId) =>
    dispatch(getAdminUserDetailsStart({ adminUserId }))

  useEffect(() => {
    dispatch(getAllGroupsStart({ isTenant: true }))
  }, [])

  useEffect(() => {
    if (groupId && groups) {
      const selectedOption = groups.find((g) => g.id === groupId)
      setSelectedGroup(selectedOption ? { label: selectedOption.groupName, value: selectedOption.id } : null)
    }
  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const options = groups.map(g => ({ label: g.groupName, value: g.id }))
      setGroupOptions(options)
    }
  }, [groups])

  useEffect(() => {
    let options = []
    if (tenantsList?.rows?.length) {
      options = tenantsList?.rows?.map((item) => { return ({ label: `${item.name} (${item.tenantId})`, value: item.tenantId }) })
      setTenantIdOptions(options)
    }
  }, [tenantsList])

  const getUpdatedData = () => {
    return tenantsList?.rows?.map((item) => { return tenantIds?.includes(item?.tenantId) && ({ label: `${item.name} (${item.tenantId})`, value: item.tenantId }) })?.filter(val => val !== false)
  }

  return {
    getAdminUserDetails,
    navigate,
    tenantAdminRole,
    getPermissionLabel: permissionLabel,
    updateTenantAdminUser,
    createTenantAdminUser,
    adminDetails,
    type,
    setType,
    groupOptions,
    setGroupOptions,
    selectedGroup,
    setSelectedGroup,
    groupDetail,
    dispatch,
    tenantIdOptions,
    tenantsList,
    getUpdatedData,
    tenantAdminsData
  }
}

export default useCreateAdminUser
